document.addEventListener('DOMContentLoaded', function(){
  var btn = document.querySelector('[data-hr-menu-toggle]');
  var header = document.querySelector('[data-hr-header]');
  if(btn && header){
    btn.addEventListener('click', function(){
      var open = header.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  document.querySelectorAll('[data-hr-back]').forEach(function(link){
    link.addEventListener('click', function(event){
      if(window.history.length > 1){event.preventDefault();window.history.back();}
    });
  });
});

(function(){
  function initProductGallery(root){
    var galleries=(root||document).querySelectorAll('[data-product-gallery]');
    galleries.forEach(function(gallery){
      if(gallery.getAttribute('data-gallery-ready')==='true')return;
      var section=gallery.closest('.shopify-section')||gallery.closest('.hr-product')||document;
      var mainButton=gallery.querySelector('[data-product-main-trigger]');
      var mainImage=gallery.querySelector('.hr-product__main-image');
      var expandButton=gallery.querySelector('[data-product-expand]');
      var zoomHint=gallery.querySelector('[data-product-zoom-hint]');
      var lightbox=section.querySelector('[data-product-lightbox]');
      var lightboxImage=section.querySelector('[data-product-lightbox-image]');
      var closeButton=section.querySelector('[data-product-lightbox-close]');
      if(!mainButton||!mainImage)return;
      gallery.setAttribute('data-gallery-ready','true');

      gallery.addEventListener('click',function(event){
        var thumb=event.target.closest('[data-product-thumb]');
        if(!thumb||!gallery.contains(thumb))return;
        event.preventDefault();
        var src=thumb.getAttribute('data-image-src');
        var zoomSrc=thumb.getAttribute('data-zoom-src')||src;
        var alt=thumb.getAttribute('data-image-alt')||'';
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.setAttribute('src',src);
        mainImage.setAttribute('alt',alt);
        mainButton.setAttribute('data-zoom-src',zoomSrc);
        mainButton.classList.remove('is-zoomed');
        mainButton.setAttribute('aria-pressed','false');
        if(zoomHint)zoomHint.textContent='Click to magnify';
        if(lightboxImage){lightboxImage.setAttribute('src',zoomSrc);lightboxImage.setAttribute('alt',alt);}
        gallery.querySelectorAll('[data-product-thumb]').forEach(function(item){
          var active=item===thumb;
          item.classList.toggle('is-active',active);
          item.setAttribute('aria-current',active?'true':'false');
        });
      });

      mainButton.addEventListener('click',function(event){
        event.preventDefault();
        var zoomed=mainButton.classList.toggle('is-zoomed');
        mainButton.setAttribute('aria-pressed',zoomed?'true':'false');
        if(zoomHint)zoomHint.textContent=zoomed?'Click to reduce':'Click to magnify';
      });
      mainButton.addEventListener('pointermove',function(event){
        if(!mainButton.classList.contains('is-zoomed'))return;
        var rect=mainButton.getBoundingClientRect();
        mainImage.style.transformOrigin=(((event.clientX-rect.left)/rect.width)*100)+'% '+(((event.clientY-rect.top)/rect.height)*100)+'%';
      });
      mainButton.addEventListener('pointerleave',function(){mainImage.style.transformOrigin='50% 50%';});

      function openLightbox(){
        if(!lightbox||!lightboxImage)return;
        lightboxImage.setAttribute('src',mainButton.getAttribute('data-zoom-src')||mainImage.src);
        lightboxImage.setAttribute('alt',mainImage.alt||'Product image');
        lightbox.hidden=false;
        document.documentElement.classList.add('hr-lightbox-open');
        if(closeButton)closeButton.focus();
      }
      function closeLightbox(){
        if(!lightbox)return;
        lightbox.hidden=true;
        document.documentElement.classList.remove('hr-lightbox-open');
        if(expandButton)expandButton.focus();
      }
      if(expandButton)expandButton.addEventListener('click',function(event){event.preventDefault();event.stopPropagation();openLightbox();});
      if(closeButton)closeButton.addEventListener('click',closeLightbox);
      if(lightbox)lightbox.addEventListener('click',function(event){if(event.target===lightbox)closeLightbox();});
      document.addEventListener('keydown',function(event){if(event.key==='Escape'&&lightbox&&!lightbox.hidden)closeLightbox();});
    });
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initProductGallery(document);});
  else initProductGallery(document);
  document.addEventListener('shopify:section:load',function(event){initProductGallery(event.target);});
})();
